import { useNavigate } from '@tanstack/react-router'
import { type ReactNode, useEffect } from 'react'

import { SidebarProvider } from '@/components/ui/sidebar'
import { useIdleLogout } from '@/hooks/use-idle-logout'
import { useRealtimeInvalidation } from '@/hooks/useRealtimeInvalidation'
import { useUser } from '@/providers/user-provider'

import { VerticalLayout } from './vertical-layout'

export function Layout({ children }: { children: ReactNode }) {
  // Connect to the real-time WebSocket for automatic cache invalidation.
  // When another user modifies data in the same tenant, the WS pushes
  // an invalidation signal and TanStack Query refetches the affected
  // queries — no page refresh needed.
  useRealtimeInvalidation()
  // Uitloggen na inactiviteit, als de urenregistratie dat instelt (besluit 23).
  useIdleLogout()

  // Wie 2FA moet gebruiken en hem niet aan heeft, gaat meteen naar het instelscherm in plaats van
  // eerst tegen de 403 van de backend aan te lopen.
  const navigate = useNavigate()
  const twoFactor = useUser().current?.user?.twoFactor
  const mustSetUp = !!twoFactor?.required && !twoFactor.enabled
  useEffect(() => {
    if (mustSetUp) void navigate({ to: '/setup-2fa', replace: true })
  }, [mustSetUp, navigate])
  if (mustSetUp) return null

  // SidebarProvider renders a full-page layout `<div>` wrapper, so it
  // only belongs on dashboard pages that actually render a sidebar.
  // Mounting it at app root would force every public page (/login,
  // /404, etc.) into the sidebar layout scaffold.
  return (
    <SidebarProvider>
      <VerticalLayout>{children}</VerticalLayout>
    </SidebarProvider>
  )
}
